<template>
	<div class="p_m_t_20">
		<div class="p_flex  p_m_t_20 p_f_a" v-for="(item, index) in Inputarrs" :key="index">
			<div class="p_f_1  type_size_18  ">
				<el-input type="textarea"  :autosize="{ minRows: 4}" v-model="item.customItem" placeholder="请输入账户"></el-input>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			radio:0,
			Inputarrs: [{'value': 1, 'customItem': ''},{'value': 1, 'customItem': ''}]
		};
	},
	mounted() {},
	methods: {
	}
};
</script>

<style lang="scss" scoped>
	.p_logins {
		height: 64px;
		background: #f5f5f5;
		opacity: 1;
		border-radius: 10px;
	}
	>>>.el-textarea__inner{
		border: none;
		background-color: #f5f5f5;
		font-size: 18px;
		color: #333;
		padding: 20px;
	}
	>>> textarea::-webkit-input-placeholder {
		font-size: 18px;
	}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/textbox.vue